var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 13.4375,
    x2: 86,
    y2: 158.291061,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.078432%,75.686276%,36.078432%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(93.333334%,52.941179%,0%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 123.625,
    y1: 135.71875,
    x2: 123.625,
    y2: 151.112747,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(98.431373%,91.37255%,77.64706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100%,72.941178%,37.254903%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 100.78125,
    y1: 87.128754,
    x2: 100.78125,
    y2: 113.227058,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(98.431373%,91.37255%,77.64706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100%,72.941178%,37.254903%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface9209770"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 40.625 34.375 L 40.625 15.625 C 40.625 13.902344 39.222656 12.5 37.5 12.5 C 36.929688 12.5 36.71875 12.664062 35.9375 12.933594 L 35.9375 11.328125 C 35.9375 9.390625 34.359375 7.8125 32.421875 7.8125 C 31.699219 7.8125 31.25 8.03125 30.46875 8.40625 L 30.46875 8.203125 C 30.46875 6.265625 28.890625 4.6875 26.953125 4.6875 C 25.015625 4.6875 23.4375 6.265625 23.4375 8.203125 L 23.4375 8.40625 C 22.65625 8.03125 22.207031 7.8125 21.484375 7.8125 C 19.546875 7.8125 17.96875 9.390625 17.96875 11.328125 L 17.980469 27.816406 L 15.550781 25.859375 C 13.964844 24.558594 11.59375 24.761719 10.261719 26.3125 C 9.613281 27.070312 9.304688 28.027344 9.390625 29.011719 C 9.476562 30 9.949219 30.894531 10.726562 31.53125 L 19.59375 38.839844 C 19.082031 39.269531 18.75 39.90625 18.75 40.625 L 18.75 42.96875 C 18.75 44.261719 19.800781 45.3125 21.09375 45.3125 L 36.71875 45.3125 C 38.011719 45.3125 39.0625 44.261719 39.0625 42.96875 L 39.0625 40.625 C 39.0625 39.925781 38.746094 39.300781 38.257812 38.871094 C 39.6875 37.886719 40.625 36.238281 40.625 34.375 Z M 10.945312 28.875 C 10.898438 28.3125 11.074219 27.765625 11.449219 27.332031 C 12.230469 26.417969 13.628906 26.300781 14.566406 27.070312 L 17 29.03125 C 17.472656 29.410156 18.105469 29.484375 18.652344 29.222656 C 19.199219 28.960938 19.539062 28.421875 19.539062 27.8125 L 19.53125 11.328125 C 19.53125 10.25 20.40625 9.375 21.484375 9.375 C 22.5625 9.375 23.4375 10.25 23.4375 11.328125 L 23.4375 19.53125 L 25 19.53125 L 25 8.203125 C 25 7.125 25.875 6.25 26.953125 6.25 C 28.03125 6.25 28.90625 7.125 28.90625 8.203125 L 28.90625 19.53125 L 30.46875 19.53125 L 30.46875 11.328125 C 30.46875 10.25 31.34375 9.375 32.421875 9.375 C 33.5 9.375 34.375 10.25 34.375 11.328125 L 34.375 19.53125 L 35.9375 19.53125 L 35.9375 15.625 C 35.9375 14.761719 36.636719 14.0625 37.5 14.0625 C 38.363281 14.0625 39.0625 14.761719 39.0625 15.625 L 39.0625 34.375 C 39.0625 36.527344 37.308594 38.28125 35.15625 38.28125 L 22.21875 38.28125 C 21.675781 38.28125 21.144531 38.089844 20.722656 37.746094 L 11.71875 30.324219 C 11.269531 29.957031 10.996094 29.441406 10.945312 28.875 Z M 36.71875 39.84375 C 37.148438 39.84375 37.5 40.195312 37.5 40.625 L 37.5 42.96875 C 37.5 43.398438 37.148438 43.75 36.71875 43.75 L 21.09375 43.75 C 20.664062 43.75 20.3125 43.398438 20.3125 42.96875 L 20.3125 40.625 C 20.3125 40.195312 20.664062 39.84375 21.09375 39.84375 Z M 36.71875 39.84375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 36.71875 43.75 L 34.375 43.75 L 34.375 39.84375 L 36.71875 39.84375 C 37.148438 39.84375 37.5 40.191406 37.5 40.625 L 37.5 42.96875 C 37.5 43.398438 37.152344 43.75 36.71875 43.75 Z M 36.71875 43.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 32.226562 25 C 30.75 25 29.535156 26.042969 29.332031 27.398438 L 29.265625 27.398438 C 29.058594 26.042969 27.84375 25 26.367188 25 C 24.75 25 23.4375 26.253906 23.4375 27.800781 C 23.4375 31.074219 26.6875 33.242188 28.347656 34.136719 C 28.941406 34.453125 29.652344 34.453125 30.246094 34.136719 C 31.90625 33.242188 35.15625 31.074219 35.15625 27.800781 C 35.15625 26.253906 33.84375 25 32.226562 25 Z M 32.226562 25 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.483f8965.svg";
export { ForwardRef as ReactComponent };